import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function PageCTA() {
  return <section className="py-24 bg-[#0a0a0a] relative overflow-hidden" data-id="element-187">
      <div className="section-divider absolute top-0" data-id="element-188"></div>

      {/* Premium Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-[400px] bg-brand-emerald/15 blur-[120px] rounded-full pointer-events-none" data-id="element-189"></div>
      <div className="absolute inset-0 bg-grid-pattern opacity-20 pointer-events-none" data-id="element-190"></div>

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-191">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 30
      }} whileInView={{
        opacity: 1,
        scale: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="bg-gradient-to-b from-[#151515] to-[#0a0a0a] rounded-2xl md:rounded-[3rem] p-8 sm:p-10 md:p-24 text-center border border-white/10 shadow-[0_0_50px_rgba(0,0,0,0.5)] relative overflow-hidden group" data-id="element-192">
          {/* Animated border top */}
          <div className="absolute top-0 inset-x-0 h-1 bg-gradient-to-r from-transparent via-brand-emerald to-transparent opacity-50 group-hover:opacity-100 transition-opacity duration-500" data-id="element-193"></div>

          <div className="absolute inset-0 bg-noise opacity-[0.03] mix-blend-overlay pointer-events-none" data-id="element-194"></div>

          <h2 className="text-4xl md:text-6xl font-black text-white mb-6 tracking-tighter relative z-10" data-id="element-195">
            Es el momento de <span className="text-gradient" data-id="element-196">dar el paso</span>
          </h2>
          <p className="text-gray-400 text-lg md:text-2xl mb-12 max-w-2xl mx-auto leading-relaxed relative z-10 font-medium" data-id="element-197">
            Tu competencia ya está online. Es hora de que tú también lo estés
            con una presencia que realmente funcione.
          </p>

          <div className="flex flex-col items-center justify-center relative z-10" data-id="element-198">
            <Link to="/checkout" className="inline-flex justify-center items-center gap-3 bg-brand-emerald text-white px-8 py-4 text-lg sm:px-10 sm:py-5 sm:text-xl rounded-2xl font-bold hover:bg-brand-emeraldLight transition-all duration-300 shadow-[0_0_40px_rgba(16,185,129,0.3)] hover:shadow-[0_0_60px_rgba(16,185,129,0.5)] hover:-translate-y-1 group/btn relative overflow-hidden mb-4" data-id="element-199">
              <span className="relative z-10" data-id="element-200">Solicitar mi proyecto</span>
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover/btn:animate-[shimmer_1.5s_infinite]" data-id="element-201"></div>
              <ArrowRight size={24} className="group-hover/btn:translate-x-1 transition-transform relative z-10" data-id="element-202" />
            </Link>
            <p className="text-sm text-gray-400 font-medium" data-id="element-203">
              Solo 50€ para empezar · Sin compromiso
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}